module.exports = __webpack_public_path__ + "static/TIF-Work-photo-332c3cbac4099bba8a643c4900719109.jpg";